<div id="Home_section">
  <div class="carousel-container">
    <div class="carousel-slide">
      <img
        [src]="slides[currentSlide].image"
        [alt]="slides[currentSlide].alt"
        class="carousel-image current"
        [class.fade-out]="isAnimating"
      />
      <img
        [src]="slides[nextSlideIndex].image"
        [alt]="slides[nextSlideIndex].alt"
        class="carousel-image next"
        [class.fade-in]="isAnimating"
      />
    </div>

    <button
      *ngIf="slides.length > 1"
      class="carousel-btn prev"
      (click)="prevSlide()"
    >
      <i class="fas fa-chevron-left"></i>
    </button>
    <button
      *ngIf="slides.length > 1"
      class="carousel-btn next"
      (click)="nextSlide()"
    >
      <i class="fas fa-chevron-right"></i>
    </button>

    <div class="carousel-indicators" *ngIf="slides.length > 1">
      <span
        *ngFor="let slide of slides; let i = index"
        class="indicator"
        [class.active]="i === currentSlide"
        (click)="goToSlide(i)"
      >
      </span>
    </div>
  </div>

  <div class="home">
    <div class="container">
      <div class="welcome-note">
        <h2>Welcome</h2>
        <p>
          Welcome the Vendor Portal for the City of Destin. New vendors who have
          just begun providing goods or services to the City or who wish to do
          business with the City in the future are encouraged to officially
          register with the City by clicking on the New Vendor Registration link
          and completing the registration form. Under Vendor Type, Active
          indicates a vendor that is currently or imminently engaging the City
          in business transactions. Prospective, on the other hand, indicates
          that your entity is not currently engaged with the City but wishes or
          intends to do business with the City at some point in the future.
          Within the Registration Form, you can click yes to be included in
          future bid opportunities. By doing so, any competitive written bids
          prepared by the City will be emailed to you once publicly issued if
          the nature and purpose of the solicitation relates in any way to your
          business. Be sure to click on Contact to add your contact information
          including email address within the form.
        </p>
        <p>
          If you are an existing vendor currently doing business with the City
          of Destin, please submit any invoices requiring payment by the City by
          clicking on the ‘Vendor Invoice Submission’ link. If there is a
          purchase order associated with the goods or services you are providing
          the City, please enter your purchase order number in the applicable
          space provided. If you are unsure of the purchase order number
          associated with the goods or services you are delivering, you can
          contact the Finance Department, at
          Accountspayable&#64;cityofdestin.com. Be sure to attach your invoice
          and any other pertinent documentation when submitting.
        </p>
        <p>
          We would like to thank you for doing business with the City of Destin,
          either currently or in the future. By entering this pertinent
          information into the New Vendor Registration portal or the Vendor
          Invoice Submission portal, we will be able to communicate new business
          opportunities to you timely and streamline the invoice submission
          process so that you can be paid quickly and accurately. We look
          forward to your continued engagement with the City.
        </p>
      </div>

      <div class="features-box">
        <h3>Our Features</h3>
        <div class="pathway-container">
          <div class="pathway-line"></div>
          <div class="features-row">
            <div class="feature" *appPortalFeature="'registration'">
              <div class="step-badge">
                <span class="step-number">1</span>
                <div class="step-icon">
                  <i class="fas fa-user-plus"></i>
                </div>
              </div>
              <div class="feature-content">
                <h3>New Vendor Registration</h3>
                <small
                  >Note: City will receive your registration. Once approved by
                  the city, you will receive an automated email with your vendor
                  ID and can proceed to step 2.
                </small>
                <a
                  href="/vendor-registration"
                  type="button"
                  class="feature-link post-tag"
                >
                  <i class="fas fa-user-plus"></i> Register Now
                </a>
              </div>
            </div>

            <div class="pathway-connector">
              <div class="connector-line"></div>
              <div class="connector-arrow">
                <i class="fas fa-arrow-down"></i>
              </div>
            </div>

            <div class="feature" *appPortalFeature="'signup'">
              <div class="step-badge">
                <span class="step-number">2</span>
                <div class="step-icon">
                  <i class="fas fa-cog"></i>
                </div>
              </div>
              <div class="feature-content">
                <h3>Profile Setup</h3>
                <small
                  >Once you receive your vendor ID, you can proceed with setting
                  up a username and password to submit invoices and monitor
                  invoice and Purchase Order history.
                </small>
                <a href="/vendor-sign-up" class="feature-link">
                  <i class="fas fa-cog"></i> Setup Profile
                </a>
              </div>
            </div>

            <div class="pathway-connector">
              <div class="connector-line"></div>
              <div class="connector-arrow">
                <i class="fas fa-arrow-down"></i>
              </div>
            </div>

            <div class="feature" *appPortalFeature="'invoice'">
              <div class="step-badge">
                <span class="step-number">3</span>
                <div class="step-icon">
                  <i class="fas fa-file-invoice-dollar"></i>
                </div>
              </div>
              <div class="feature-content">
                <h3>Vendor Invoice Submission</h3>
                <small
                  >Once profile is setup, you can begin submitting invoices
                  through the Vendor Invoice Submission page and monitor
                  progress via your profile.
                </small>
                <a href="/vendor-invoice" class="feature-link" *appPortalButton>
                  <i class="fas fa-file-invoice-dollar"></i> Submit Invoices
                </a>
                <a href="/login" *appPortalLoginRequired class="feature-link">
                  <i class="fas fa-lock"></i> Login Required
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
